import axios from 'axios';

const API = axios.create({ baseURL: '/api', timeout: 30000 }); // 30s global timeout

API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('crm_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

API.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status;
    // 401 Unauthorized — token invalid or expired → force login
    if (status === 401) {
      const onLoginPage = window.location.pathname === '/login';
      if (!onLoginPage) {
        localStorage.removeItem('crm_token');
        localStorage.removeItem('crm_user');
        window.location.href = '/login?reason=session_expired';
      }
    }
    // 403 Forbidden — authenticated but insufficient role
    // Don't redirect — let the page handle it with a toast
    if (status === 403) {
      err.userMessage = 'You do not have permission to perform this action.';
    }
    // Network error (server down, offline)
    if (!err.response) {
      err.userMessage = 'Cannot connect to server. Check your network connection.';
    }
    return Promise.reject(err);
  }
);

// authImg() — for <img src> tags pointing at the auth-gated /uploads mount
// (see backend/middleware/uploadsAuth.js). A plain <img> can't attach an
// Authorization header, so the JWT has to ride along as a ?token= query
// param instead — same fallback the auth-gated report/PDF download links
// already use. Non-/uploads paths (e.g. /product-images) pass through
// unchanged since that mount isn't auth-gated.
export function authImg(path) {
  if (!path) return path;
  if (!path.startsWith('/uploads/')) return path;
  const token = localStorage.getItem('crm_token');
  return token ? `${path}${path.includes('?') ? '&' : '?'}token=${token}` : path;
}

export default API;
